import _ from 'lodash'
import classNames from 'classnames'
import React from 'react'

import { Entity } from 'shared-libs/models/entity'
import { CacUtils } from 'shared-libs/helpers/cacUtils'

import './_pre-check-detail-card.scss'

/**
 * @uiComponent
 *
 * Mobile-web Pre-Check (CAC) detail card — web twin of the native
 * PreCheckDetailCard. Tinted header with title, status pill and TMS ID,
 * followed by appointment / pickup / dropoff / shipment / carrier / trailer
 * rows. Presentation logic is shared via shared-libs/helpers/cacUtils.
 */
interface IPreCheckDetailCardProps {
  entity?: Entity
  frames?: any
}

export class PreCheckDetailCard extends React.PureComponent<IPreCheckDetailCardProps> {

  public render() {
    const entity = this.props.entity ?? this.props.frames?.getValue('entity')
    if (_.isEmpty(entity)) {
      return null
    }

    const hasCheckIn = CacUtils.hasCheckInStarted(entity)
    const appointmentNumber = CacUtils.getAppointmentNumber(entity)

    const rows = [
      { label: 'Appointment', value: CacUtils.formatAppointmentTime(entity) },
      { label: 'Pickup', value: CacUtils.getPickupName(entity), sub: CacUtils.getPickupAddress(entity) },
      { label: 'Dropoff', value: CacUtils.getDropoffName(entity), sub: CacUtils.getDropoffAddress(entity) },
      { label: 'Shipment #', value: CacUtils.getShipmentId(entity) },
      { label: 'Carrier', value: CacUtils.getCarrierName(entity) },
      { label: 'Trailer', value: CacUtils.getTrailer(entity) || 'TBD' },
    ]

    return (
      <div className="pre-check-card">
        <div className="pre-check-card__header">
          <div className="pre-check-card__headerTop">
            <div className="pre-check-card__title">{CacUtils.buildTitle(entity)}</div>
            <div className={classNames('pre-check-card__pill', hasCheckIn ? 'pre-check-card__pill--progress' : 'pre-check-card__pill--upcoming')}>
              {hasCheckIn ? 'In Progress' : 'Upcoming'}
            </div>
          </div>
          {appointmentNumber && <div className="pre-check-card__tms">TMS ID: {appointmentNumber}</div>}
        </div>
        {rows.map((row) => (row.value ? (
          <div className="pre-check-card__row" key={row.label}>
            <div className="pre-check-card__label">{row.label}</div>
            <div className="pre-check-card__valueCol">
              <div className="pre-check-card__value">{row.value}</div>
              {row.sub ? <div className="pre-check-card__sub">{row.sub}</div> : null}
            </div>
          </div>
        ) : null))}
      </div>
    )
  }
}
